<select [(ngModel)]="lstIndex" (change)="CambiarEstado()">
    <option *ngFor="let estado of ESTADOS; let i = index" [value]="i">{{ estado.name }}</option>
</select>